import actionTypes from '../actions/terms-of-use.action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_TERMS_OF_USE_REQUEST:
    case actionTypes.FETCH_TERMS_OF_USE_SUCCESS:
    case actionTypes.FETCH_TERMS_OF_USE_FAILURE:
      return action.hasError;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/components/reducers/terms-of-use-error.js